// --- Our Modules --------------------------------------------------------------------------------
import type { Lang } from "@/hooks/useLang/types";
// --- Logic --------------------------------------------------------------------------------------
/**
 * When an order was placed, written the way a person says it: "18 October - 3:47 PM".
 *
 * The month is named rather than numbered because `18/10` and `10/18` are the same six characters in
 * two different orders, and a counter reading quickly has no way to tell which one it is looking at.
 *
 * Arabic keeps Latin digits (`-u-nu-latn`) so a time reads the same as every price and order number
 * on the same screen, and takes its month name and its ص/م from the language.
 */
export const formatOrderTime = (iso: string, lang: Lang): string => {
    const at = new Date(iso);
    if (isNaN(at.getTime())) return "";

    const locale = lang === "ar" ? "ar-EG-u-nu-latn" : "en-US";
    const day = at.toLocaleDateString(locale, { day: "numeric", month: "long" });
    const time = at.toLocaleTimeString(locale, { hour: "numeric", minute: "2-digit", hour12: true });

    return `${day} - ${time}`;
};
